import { createElement as rc } from 'react';
import IconOld from './Icon.old';
import { iconNameMapping } from './Icons/BaseIconAdapterGl2025';

const oldIconNameMapping = Object.entries(iconNameMapping).reduce(
    (acc, [key, value]) => {
        acc[value] = key;
        return acc;
    },
    {
        'plus-circle': 'add',
        'plus-square': 'add',
        sliders_01: 'view_week'
    }
);

function mapIconName(iconName) {
    if (!iconName) return iconName;
    const normalized = iconName.replace(/_/g, '-');
    return (oldIconNameMapping[normalized] ?? iconName).replace(/-|\s/g, '_');
}

function OldIconAdapter(props) {
    const {
        name,
        color, // icon color for new BaseIcon component
        fontColor, // icon color for old Icon component
        children,
        ...otherProps
    } = props;

    const [iconName, ...rest] = children?.split('|') ?? [];
    const oldIconName = iconName?.replace(/_/g, '-');
    const resolvedName = mapIconName(name ?? oldIconName) + (rest.length ? '|' + rest.join('|') : '');

    return rc(
        IconOld,
        {
            fontColor: fontColor ?? color ?? 'currentColor',
            color,
            ...otherProps
        },
        resolvedName
    );
}

export default OldIconAdapter;
